<template>
  <div>
    <a-row>
      <g-master name="Seguimientos"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :parentData="parentData"
                modalWidth="100%"
                ref="master"
      >
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Descripción Cualitativa')">
                <a-textarea autoSize
                            v-decorator="['qualitative_description', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Fecha Realización Seguimiento')">
                <a-date-picker style="width: 100%" valueFormat="Y-MM-DD 00:00:00"
                               v-decorator="['monitoring_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  export default {
    props: ['id_competencia'],
    data () {
      return {
        selOptions: {
          allowClear: true
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'eva_comp_seguimiento',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {
                title: 'Descripción Cualitativa',
                dataIndex: 'qualitative_description',
                align: 'center',
                sorter: true,
                width: 850
              },
              {title: 'Fecha Realizo Seguimiento', dataIndex: 'fecha_moni', align: 'center', sorter: true}
            ]
          },
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_eva_competency: this.id_competencia
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Evaluaciones/Complemento/CompSeguimiento.vue